import { useEffect } from 'react';
import ExportDropdownItems from './ExportDropdownItems';
import { Dropdown } from 'semantic-ui-react';
import DownloadInventoryStickersModal from '@components/Inventory/DownloadInventoryStickersModal';
import { useTranslation } from 'react-i18next';
import { entityType as et } from '../../../../../constants';
import { FileType } from '@behavior/reports/types';

type Props = {
  isRenderExport: boolean;
  isReportLoading: boolean;
  selectedRows: any;
  gridTemplatesOptions: any;
  actions: any;
  filterState: any;
  allFilters: any;
  entityType: string;
};

const ExportDropdown = ({
  isRenderExport,
  isReportLoading,
  selectedRows,
  gridTemplatesOptions,
  actions,
  filterState,
  allFilters,
  entityType,
}: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    allFilters[et.inventoryAllForExport] = JSON.parse(JSON.stringify(allFilters[entityType]));
    allFilters[et.inventoryAllForExport].filteredList.entityType = entityType;
    allFilters[et.inventoryAllForExport].filteredList.result = [];
  }, [allFilters[entityType].filters]);

  const fileTypes = Object.values(FileType) as FileType[];

  return isRenderExport ? (
    <Dropdown
      text={t('inventory.overview.page.view.options.container.export.button')}
      icon="download"
      labeled
      button
      className="icon mini"
      loading={isReportLoading}
    >
      <Dropdown.Menu>
        <DownloadInventoryStickersModal
          selectedInventoriesDict={selectedRows}
          gridTemplateCreatorOptions={gridTemplatesOptions}
          downloadFileName="inventory-qr-stickers.pdf"
          isDropdownItem
          classNamePopup={``}
        />
        {fileTypes.map(fileType => (
          <ExportDropdownItems
            fileType={fileType}
            selectedRows={selectedRows}
            actions={actions}
            filterState={filterState}
            allFilters={allFilters}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <></>
  );
};

export default ExportDropdown;
